import { InventoryBoundary } from '@cibo/core'
import { ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { BoundaryThumbnail } from 'features/Inventories/components/BoundaryThumbnail'
import { useTranslation } from 'react-i18next'

export const BoundariesListItem = ({
  boundary,
}: {
  boundary?: Pick<InventoryBoundary, 'name' | 'areaDef' | 'crops'>
}) => {
  const { t: cropsT } = useTranslation('@cibo/ui/cropNames')

  if (!boundary) return null

  return (
    <ListItem>
      <ListItemAvatar>
        <BoundaryThumbnail
          boundary={boundary}
          height={36}
          width={36}
          style={{ borderRadius: 0.5 }}
        />
      </ListItemAvatar>
      <ListItemText
        primary={boundary.name}
        secondary={boundary.crops.map(c => cropsT(c.crop)).join(', ')}
        sx={{ flex: 3, wordWrap: 'break-word' }}
      />
    </ListItem>
  )
}
